import React from "react";
import { Badge } from "antd";
import { useIntl } from "react-intl";

const EmployeeStatus = (props) => {
  const { record } = props;
  const intl = useIntl();
  let status = "active";
  switch (record.status) {
    case 1:
      status = "active";
      break;

    case 2:
      status = "not_active";
      break;

    case 3:
      status = "candidate";
      break;

    default:
      break;
  }
  return status ? (
    <Badge
      status={
        status === "active"
          ? "success"
          : status === "not_active"
          ? "error"
          : "default"
      }
      text={intl.formatMessage({
        id: `app.forms.${status}`,
      })}
    />
  ) : null;
};

export default EmployeeStatus;
